<template>
    <b-overlay :show="isLoading">
        <b-card class="m-4">
            <b-row class="mb-2">
                <b-col cols="12">
                    <h3 v-if="$route.name === 'PublicationNew'">Nueva publicación</h3>
                    <h3 v-else>Modificar publicación</h3>
                </b-col>
            </b-row>

            <ValidationProvider rules="required" v-slot="{ errors }">
                <b-row class="mb-5" v-if="publication.id === 0">
                    <b-col class="text-left d-flex" cols="12" md="6" lg="5">
                        <div class="d-flex">
                            <b class="align-self-center">Cliente:</b>
                        </div>
                        <div class="flex-grow-1 ml-2">
                            <v-select label="legalName" :options="customers" debounce="300" placeholder="Cliente" :class="customerSelectClass(errors)"
                                      @search="getCustomers" @search:focus="getCustomers" :filterable="false" v-model="publication.customer">
                                <template slot="no-options">Sin resultados.</template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.legalName }}
                                        <template v-if="option.email"><br>{{ option.email }}</template>
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">{{ option.legalName }}</div>
                                </template>
                            </v-select>
                            <small v-if="errors[0]" class="text-danger">Selecciona el cliente</small>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mb-5 text-left" v-else>
                    <b-col>
                        <h5><b>Cliente: </b> {{ publication.customer.legalName }}</h5>
                    </b-col>
                </b-row>
            </ValidationProvider>

<!--            <b-row class="mb-2">-->
<!--                <b-col cols="12">-->
<!--                    <h3>Nueva publicación</h3>-->
<!--                </b-col>-->
<!--            </b-row>-->
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.prevent="passes(addPublication)" id="publication-form">
                    <b-row>
                        <b-col cols="12" md="9" lg="10">
                            <b-row class="text-left">
                                <!--<b-col cols="12" md="4" :lg="true">-->
                                <!--                                <ValidationProvider rules="required" v-slot="{ errors }">   invalid-feedback="Ingresa el folio"  :state="errors[0] ? false : null" -->
                                <!--<b-form-group>-->
                                <!--<b-form-input v-model="publication.folio" autocomplete="false" placeholder="Folio"-->
                                <!--:disabled="post.customer === null"></b-form-input>-->
                                <!--</b-form-group>-->
                                <!--                                </ValidationProvider>-->
                                <!--</b-col>-->
                                <b-col cols="12" md="4" :lg="true" v-if="customFieldsEnabled.includes('field1')">
                                    <ValidationProvider :rules="customFields[0].required ? 'required' : ''" v-slot="{ errors }">
                                        <b-form-group :label="customFields[0].placeholder" :invalid-feedback="invalidFeedback" :state="errors[0] ? false : null">
                                            <b-input :placeholder="customFields[0].placeholder" v-model="publicationItem.field1"
                                                     :state="errors[0] ? false : null" :disabled="publication.customer === null"
                                                      v-if="customFields[0].type === 'TEXT'"></b-input>
                                            <PSDatePicker v-else-if="customFields[0].type === 'DATETIME'" :format="calendar.format"
                                                          :language="calendar.language" :placeholder="customFields[0].placeholder"
                                                          :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                                          :entity="publicationItem" field="field1" @input-changed="dateChanged"
                                                          v-model="publicationItem.field1" :model="publicationItem.field1"></PSDatePicker>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4" :lg="true" v-if="customFieldsEnabled.includes('field2')">
                                    <ValidationProvider :rules="customFields[1].required ? 'required' : ''" v-slot="{ errors }">
                                        <b-form-group :label="customFields[1].placeholder" :invalid-feedback="invalidFeedback" :state="errors[0] ? false : null">
                                            <b-input :placeholder="customFields[1].placeholder" v-model="publicationItem.field2"
                                                     :state="errors[0] ? false : null" :disabled="publication.customer === null"
                                                     v-if="customFields[1].type === 'TEXT'"></b-input>
                                            <PSDatePicker v-else-if="customFields[1].type === 'DATETIME'" :format="calendar.format"
                                                          :language="calendar.language" :placeholder="customFields[1].placeholder"
                                                          :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                                          :entity="publicationItem" field="field2" @input-changed="dateChanged"
                                                          v-model="publicationItem.field2" :model="publicationItem.field2"></PSDatePicker>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4" :lg="true" v-if="customFieldsEnabled.includes('field3')">
                                    <ValidationProvider :rules="customFields[2].required ? 'required' : ''" v-slot="{ errors }">
                                        <b-form-group :label="customFields[2].placeholder" :invalid-feedback="invalidFeedback" :state="errors[0] ? false : null">
                                            <b-input :placeholder="customFields[2].placeholder" v-model="publicationItem.field3"
                                                     :state="errors[0] ? false : null" :disabled="publication.customer === null"
                                                     v-if="customFields[2].type === 'TEXT'"></b-input>
                                            <PSDatePicker v-else-if="customFields[2].type === 'DATETIME'" :format="calendar.format"
                                                          :language="calendar.language" :placeholder="customFields[2].placeholder"
                                                          :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                                          :entity="publicationItem" field="field3" @input-changed="dateChanged"
                                                          v-model="publicationItem.field3" :model="publicationItem.field3"></PSDatePicker>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4" :lg="true" v-if="customFieldsEnabled.includes('field4')">
                                    <ValidationProvider :rules="customFields[3].required ? 'required' : ''" v-slot="{ errors }">
                                        <b-form-group :label="customFields[3].placeholder" :invalid-feedback="invalidFeedback" :state="errors[0] ? false : null">
                                            <b-input :placeholder="customFields[3].placeholder" v-model="publicationItem.field4"
                                                     :state="errors[0] ? false : null" :disabled="publication.customer === null"
                                                     v-if="customFields[3].type === 'TEXT'"></b-input>
                                            <PSDatePicker v-else-if="customFields[3].type === 'DATETIME'" :format="calendar.format"
                                                          :language="calendar.language" :placeholder="customFields[3].placeholder"
                                                          :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                                          :entity="publicationItem" field="field4" @input-changed="dateChanged"
                                                          v-model="publicationItem.field4" :model="publicationItem.field4"></PSDatePicker>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="4" :lg="true" v-if="customFieldsEnabled.includes('field5')">
                                    <ValidationProvider :rules="customFields[4].required ? 'required' : ''" v-slot="{ errors }">
                                        <b-form-group :label="customFields[4].placeholder" :invalid-feedback="invalidFeedback" :state="errors[0] ? false : null">
                                            <b-input :placeholder="customFields[4].placeholder" v-model="publicationItem.field5"
                                                     :state="errors[0] ? false : null" :disabled="publication.customer === null"
                                                     v-if="customFields[4].type === 'TEXT'"></b-input>
                                            <PSDatePicker v-else-if="customFields[4].type === 'DATETIME'" :format="calendar.format"
                                                          :language="calendar.language" :placeholder="customFields[4].placeholder"
                                                          :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                                          :entity="publicationItem" field="field5" @input-changed="dateChanged"
                                                          v-model="publicationItem.field5" :model="publicationItem.field5"></PSDatePicker>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row class="text-left mb-4">
                                <b-col>
                                    <label class="mb-0">Grupos</label><br>
                                    <b-row class="mt-2">
                                        <b-col cols="12">
                                            <v-select label="name" :options="groups" debounce="300" placeholder="Grupos" @search="getCustomerGroups"
                                                      @search:focus="getCustomerGroups" :filterable="false" v-model="publicationItem.groups"
                                                      multiple :disabled="publication.customer === null">
                                                <template slot="no-options">Sin resultados.</template>
                                            </v-select>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="12" md="3" lg="2">
                            <div class="d-none d-md-block" style="margin-top: 31px"></div>
                            <b-button variant="primary" type="submit" form="publication-form" class="mb-3" :disabled="publication.customer === null">
                                <font-awesome-icon icon="plus"></font-awesome-icon> Agregar
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>

            <b-table bordered striped small responsive :items="publicationItems" :fields="fields" ref="publicationTable">
                <template v-slot:head(isSelected)>
                    <div>Seleccionar</div>
                    <div><b-checkbox v-model="selectAll" @change="toggleSelectAll"></b-checkbox></div>
                </template>

                <template v-slot:cell(isSelected)="row">
                    <b-checkbox v-model="row.item.isSelected" @change="setSelectAllStatus"></b-checkbox>
                </template>

                <template v-slot:cell(folio)="row">
                    {{ row.item.folio }}
                </template>

                <template v-slot:cell(field1)="row" v-if="customFieldsEnabled.includes('field1')">
                    <template v-if="row.item.isEditing">
                        <b-input :placeholder="customFields[0].placeholder" v-model="row.item.field1" v-if="customFields[0].type === 'TEXT'"
                                 :state="row.item.state1"></b-input>
                        <PSDatePicker v-else-if="customFields[0].type === 'DATETIME'" :format="calendar.format"
                                      :language="calendar.language" :placeholder="customFields[0].placeholder" :initialValue="row.item.field1ISO"
                                      :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                      calendar-class="calendar-inline" @input-changed="dateChanged" :entity="row.item" field="field1">
                        </PSDatePicker>
                        <small v-if="row.item.state1 === false" class="text-danger">{{ invalidFeedback }}</small>
                    </template>
                    <span v-else>{{ row.item.field1 }}</span>
                </template>

                <template v-slot:cell(field2)="row" v-if="customFieldsEnabled.includes('field2')">
                    <template v-if="row.item.isEditing">
                        <b-input :placeholder="customFields[1].placeholder" v-model="row.item.field2" v-if="customFields[1].type === 'TEXT'"
                                 :state="row.item.state2"></b-input>
                        <PSDatePicker v-else-if="customFields[1].type === 'DATETIME'" :format="calendar.format"
                                      :language="calendar.language" :placeholder="customFields[1].placeholder" :initialValue="row.item.field2ISO"
                                      :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                      calendar-class="calendar-inline" @input-changed="dateChanged" :entity="row.item" field="field2">
                        </PSDatePicker>
                        <small v-if="row.item.state2 === false" class="text-danger">{{ invalidFeedback }}</small>
                    </template>
                    <span v-else>{{ row.item.field2 }}</span>
                </template>

                <template v-slot:cell(field3)="row" v-if="customFieldsEnabled.includes('field3')">
                    <template v-if="row.item.isEditing">
                        <b-input :placeholder="customFields[2].placeholder" v-model="row.item.field3" v-if="customFields[2].type === 'TEXT'"
                                 :state="row.item.state3"></b-input>
                        <PSDatePicker v-else-if="customFields[2].type === 'DATETIME'" :format="calendar.format"
                                      :language="calendar.language" :placeholder="customFields[2].placeholder" :initialValue="row.item.field3ISO"
                                      :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                      calendar-class="calendar-inline" @input-changed="dateChanged" :entity="row.item" field="field3">
                        </PSDatePicker>
                        <small v-if="row.item.state3 === false" class="text-danger">{{ invalidFeedback }}</small>
                    </template>
                    <span v-else>{{ row.item.field3 }}</span>
                </template>

                <template v-slot:cell(field4)="row" v-if="customFieldsEnabled.includes('field4')">
                    <template v-if="row.item.isEditing">
                        <b-input :placeholder="customFields[3].placeholder" v-model="row.item.field4" v-if="customFields[3].type === 'TEXT'"
                                 :state="row.item.state4"></b-input>
                        <PSDatePicker v-else-if="customFields[3].type === 'DATETIME'" :format="calendar.format"
                                      :language="calendar.language" :placeholder="customFields[3].placeholder" :initialValue="row.item.field4ISO"
                                      :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                      calendar-class="calendar-inline" @input-changed="dateChanged" :entity="row.item" field="field4">
                        </PSDatePicker>
                        <small v-if="row.item.state4 === false" class="text-danger">{{ invalidFeedback }}</small>
                    </template>
                    <span v-else>{{ row.item.field4 }}</span>
                </template>

                <template v-slot:cell(field5)="row" v-if="customFieldsEnabled.includes('field5')">
                    <template v-if="row.item.isEditing">
                        <b-input :placeholder="customFields[4].placeholder" v-model="row.item.field5" v-if="customFields[4].type === 'TEXT'"
                                 :state="row.item.state5"></b-input>
                        <PSDatePicker v-else-if="customFields[4].type === 'DATETIME'" :format="calendar.format"
                                      :language="calendar.language" :placeholder="customFields[4].placeholder" :initialValue="row.item.field5ISO"
                                      :bootstrap-styling="calendar.bootstrapStyling" :clear-button="calendar.clearButton"
                                      calendar-class="calendar-inline" @input-changed="dateChanged" :entity="row.item" field="field5">
                        </PSDatePicker>
                        <small v-if="row.item.state5 === false" class="text-danger">{{ invalidFeedback }}</small>
                    </template>
                    <span v-else>{{ row.item.field5 }}</span>
                </template>

                <template v-slot:cell(groups)="row">
                    <template v-if="row.item.isEditing">
                        <v-select label="name" :options="groups" debounce="300" placeholder="Grupos" @search="getCustomerGroups"
                                  @search:focus="getCustomerGroups" :filterable="false" v-model="row.item.groups" multiple>
                            <template slot="no-options">Sin resultados.</template>
                        </v-select>
<!--                        <v-select label="name" :options="groups" placeholder="Grupos" v-model="row.item.groups" multiple>-->
<!--                            <template slot="no-options">Sin resultados.</template>-->
<!--                            <template slot="option" slot-scope="option">-->
<!--                                <div class="d-center">{{ option.name }}</div>-->
<!--                            </template>-->
<!--                            <template slot="selected-option" slot-scope="option">-->
<!--                                <div class="selected d-center">{{ option.name }}</div>-->
<!--                            </template>-->
<!--                        </v-select>-->
                    </template>
                    <span v-else>
                        <template v-for="group in row.item.groups">
                            <b-badge variant="primary" class="p-1 ml-1" :key="group.id">{{ group.name }}</b-badge>
                        </template>
                    </span>
                </template>

                <template v-slot:cell(locked)="row">
                    <b-badge variant="danger" v-if="row.item.locked">Sí</b-badge>
                    <b-badge variant="success" v-else>No</b-badge>
                </template>

                <template v-slot:cell(status)="row">
                    <div class="text-center">
                        <b-badge variant="info" v-if="row.item.status === 'DRAFT'" class="p-1">Borrador</b-badge>
                        <b-badge variant="success" v-else>Publicado</b-badge>
                    </div>
                </template>

                <template v-slot:cell(files)="row">
                    {{ row.item.files.length }}
                </template>

                <template v-slot:cell(actions)="row">
                    <b-button-group size="sm" v-if="row.item.isEditing">
                        <b-button variant="outline-primary" @click="toggleEditing(row.item)" v-b-tooltip.hover.auto title="Cancelar">
                            <font-awesome-icon icon="ban"></font-awesome-icon>
                        </b-button>
                        <b-button variant="outline-primary" @click="savePublicationItem(row.item)" v-b-tooltip.hover.auto title="Guardar">
                            <font-awesome-icon icon="save"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                    <b-button-group size="sm" v-else>
                        <b-button variant="outline-primary" @click="toggleEditing(row.item)" v-if="row.item.status !== 'PUBLISHED'"
                                  v-b-tooltip.hover.auto title="Modificar">
                            <font-awesome-icon icon="edit"></font-awesome-icon>
                        </b-button>
                        <b-button v-b-tooltip.hover.auto @click="row.toggleDetails" variant="outline-primary"
                                  :title="row.detailsShowing ? 'Ocultar archivos' : 'Ver archivos'">
                            <font-awesome-icon :icon="row.detailsShowing ? 'minus' : 'plus'"></font-awesome-icon>
                        </b-button>
                        <b-button variant="outline-success" @click="validatePublicationNotification('LOCK', 'SINGLE', row.item)"
                                  v-b-tooltip.hover.auto title="Desbloquear descarga" v-if="row.item.locked">
                            <font-awesome-icon icon="lock-open"></font-awesome-icon>
                        </b-button>
                        <b-button variant="outline-danger" @click="validateLockItem('SINGLE', row.item, true)"
                                  v-b-tooltip.hover.auto title="Bloquear descarga" v-else>
                            <font-awesome-icon icon="lock"></font-awesome-icon>
                        </b-button>

                        <b-button variant="outline-success" @click="validatePublicationNotification('PUBLISH', 'SINGLE', row.item)"
                                  v-b-tooltip.hover.auto title="Publicar" v-if="row.item.status !== 'PUBLISHED'" :disabled="row.item.files.length <= 0">
                            <font-awesome-icon icon="cloud"></font-awesome-icon>
                        </b-button>
                        <b-button variant="outline-danger" @click="validateUnpublishItem('SINGLE', row.item, 'DRAFT')"
                                  v-b-tooltip.hover.auto title="Retirar publicación" v-else-if="row.item.files.length > 0">
                            <font-awesome-icon icon="cloud"></font-awesome-icon>
                        </b-button>
                    </b-button-group>
                </template>

                <template v-slot:row-details="row">
                    <b-card v-if="row.item.status !== 'PUBLISHED'">
                        <b-button @click="showFilesModal(row.item)">Subir archivos</b-button>
                    </b-card>

                    <template v-if="row.item.files.length > 0">
                        <b-table :items="row.item.files" :fields="fileFields"
                                 striped bordered hover small show-empty responsive style="font-size: .9rem;">
                            <template v-slot:cell(number)="fileRow">{{ fileRow.index + 1 }}</template>

                            <template v-slot:cell(size)="fileRow">{{ formatBytes(fileRow.item.size) }}</template>
                            <template v-slot:cell(isSigned)="fileRow">{{ fileRow.item.isSigned ? 'Sí' : 'No' }}</template>
                            <template v-slot:cell(actions)="fileRow">
                                <b-button-group>
                                    <b-button v-if="canBeSigned(fileRow.item, row.item.status)" v-b-tooltip.hover.auto
                                              @click="showSigningModal(row.item.id, fileRow.item)"
                                              variant="outline-primary" title="Firmar certificado" class="px-1 py-0">
                                        <font-awesome-icon icon="signature"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-b-tooltip.hover.auto v-if="canBePreviewed(fileRow.item)" @click="showPreview(fileRow.item)"
                                              variant="outline-primary" title="Vista previa" class="px-1 py-0">
                                        <font-awesome-icon icon="eye"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-b-tooltip.hover.auto @click="download(fileRow.item)"
                                              variant="outline-primary" title="Descargar" class="px-1 py-0">
                                        <font-awesome-icon icon="download"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-b-tooltip.hover.auto @click="openFileLogsModal(fileRow.item)"
                                              variant="outline-primary" title="Ver historial" class="px-1 py-0">
                                        <font-awesome-icon icon="list"></font-awesome-icon>
                                    </b-button>
                                    <b-button v-b-tooltip.hover.auto @click="deleteFile(fileRow.item.id, fileRow.item.name)"
                                              v-if="row.item.status !== 'PUBLISHED'" variant="outline-danger" title="Eliminar" class="px-1 py-0">
                                        <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                                    </b-button>
                                </b-button-group>
                            </template>
                        </b-table>
                    </template>
                    <div class="text-center" v-else> Sin archivos</div>
                </template>
            </b-table>

            <template v-slot:footer>
                <div class="text-right">
                    <b-button variant="outline-secondary" @click="$router.go(-1)">
                        <font-awesome-icon icon="angle-left"></font-awesome-icon><span class="ml-2">Regresar</span>
                    </b-button>

                    <b-dropdown id="dropdown-1" class="m-md-2" variant="primary" dropup :disabled="selectedPublicationItems.length === 0">
                        <template #button-content>
                            <font-awesome-icon icon="check-square"></font-awesome-icon><span class="ml-2">Con los seleccionados:</span>
                        </template>
                        <b-dropdown-item @click="validateUnpublishItem('SELECTED', null, 'UNPUBLISH')"
                                         :disabled="publicationItemsToUnpublish.length <= 0">
                            <font-awesome-icon icon="cloud" :class="publicationItemsToUnpublish.length === 0 ? '' : 'text-danger'">
                            </font-awesome-icon>
                            <span class="ml-2">Retirar publicación</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="validatePublicationNotification('PUBLISH', 'SELECTED')"
                                         :disabled="publicationItemsToPublish.length <= 0">
                            <font-awesome-icon icon="cloud" :class="publicationItemsToPublish.length === 0 ? '' : 'text-success'">
                            </font-awesome-icon>
                            <span class="ml-2">Publicar</span>
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="validateLockItem('SELECTED', null, true)"
                                         :disabled="publicationItemsToLock.length <= 0">
                            <font-awesome-icon icon="lock" :class="publicationItemsToLock.length === 0 ? '' : 'text-danger'">
                            </font-awesome-icon><span class="ml-2">Bloquear descarga</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="validatePublicationNotification('LOCK', 'SELECTED')"
                                         :disabled="publicationItemsToUnlock.length <= 0">
                            <font-awesome-icon icon="lock-open" :class="publicationItemsToUnlock.length === 0 ? '' : 'text-success'">
                            </font-awesome-icon><span class="ml-2">Desbloquear descarga</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>
        </b-card>

        <b-modal id="publication-modal" size="lg" no-close-on-backdrop no-close-on-esc>
            <template v-slot:modal-header>
                <h4 class="my-0">Registro #{{ modalPublication.folio }}</h4>
            </template>

            <VueDropzone id="dropzone" ref="vueDropzone" :options="dropzoneOptions" @vdropzone-success="onFileUploadSuccess"
                         @vdropzone-error="onFileUploadError"></VueDropzone>

            <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('publication-modal')" :disabled="modalPublication.files.length === 0">Cerrar</b-button>
            </template>
        </b-modal>

        <b-modal id="email-modal" size="lg" no-close-on-backdrop no-close-on-esc title="Componer correo"
                 cancel-title="Cancelar" ok-title="Publicar">
            <ValidationObserver ref="observer1" v-slot="{ passes }">
                <b-form @submit.prevent="passes(publish)" id="compose-email-form">
                    <b-form-group label="Para" v-if="(notificationType === 'SINGLE' && publicationToPublish.groups.length === 0) ||
                                                   (notificationType === 'SELECTED' && showEmailsSelect)">
                        <v-select :options="groupEmails" debounce="300" placeholder="Para"
                                  @search="getUsersEmailsByCustomer" @search:focus="getUsersEmailsByCustomer"
                                  v-model="mailData.emails" :reduce="group => group.email" multiple>
                            <template slot="no-options">Sin resultados.</template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">{{ option.name }}</div>
                                <div class="d-center" v-if="option.email">{{ option.email }}</div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">{{ option.email }}</div>
                            </template>
                        </v-select>
                        <div v-if="mailData.errors.emails" class="invalid-feedback d-block" role="alert">
                            Selecciona al menos un correo para notificar
                        </div>
                    </b-form-group>
                    <b-form-group label="Para" v-if="(notificationType === 'SINGLE' && publicationToPublish.groups.length > 0) ||
                                  (notificationType === 'SELECTED' && showGroupsTags)">
                        <template v-for="group in groupsToNotify">
                            <b-badge :id="'group-badge-' + group.id" variant="primary" :key="group.id" class="ml-1">
                                {{ group.name }}
                            </b-badge>
                            <b-popover :target="'group-badge-' + group.id" :key="group.name" triggers="hover" placement="top">
                                <template #title>Usuarios a notificar</template>
                                <template v-for="(user, index) in group.users">
                                    <span :key="user.id"><strong>{{ user.name }}: </strong>{{ user.email }}
                                        <br v-if="(index + 1) < group.users.length">
                                    </span>
                                </template>
                            </b-popover>
                        </template>
                    </b-form-group>
                    <b-form-group label="Cc" description="Correos separados por comas">
                        <b-form-input placeholder="Cc" v-model="mailData.cc"></b-form-input>
                    </b-form-group>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="Asunto" invalid-feedback="Ingresa el asunto">
                            <b-form-input placeholder="Asunto" v-model="mailData.subject" :state="errors[0] ? false : null"></b-form-input>
                        </b-form-group>
                    </ValidationProvider>
                    <label>Cuerpo del correo</label>
                    <Editor :initialValue="editorInitialValue" initialEditType="wysiwyg" :options="editorOptions"
                            @change="onEditorChange" ref="emailBody"></Editor>
                    <!--<b-form-checkbox class="mt-3 float-right" v-model="mailData.attachFiles">Adjuntar archivos</b-form-checkbox>-->
                </b-form>
            </ValidationObserver>
            <template v-slot:modal-footer="{ cancel }">
                <b-button @click="cancel">Cancelar</b-button>
                <b-button variant="success" type="submit" form="compose-email-form">
                    <font-awesome-icon :icon="notificationAction === 'LOCK' ? 'lock-open' : 'cloud'"></font-awesome-icon>
                    <span class="ml-2">{{ notificationAction === 'LOCK' ? 'Desbloquear' : 'Publicar' }}</span>
                </b-button>
            </template>
        </b-modal>

        <b-modal id="file-logs-modal" size="lg" title="Historial de descargas" ok-title="Cerrar" ok-only>
            <b-row no-gutters class="text-left">
                <b-col>
                    <b-table :items="fileLogs" :fields="fileLogsfields" empty-text="Sin registros" striped bordered hover small show-empty responsive>
                    </b-table>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="file-preview-modal" size="xl" :title="file.name" ok-title="Cerrar" ok-only>
            <iframe class="object" :src="file.previewData" style="width: 100%; height: 650px;"></iframe>`
        </b-modal>

        <SigningModal :modal-publication-item-id="modalPublicationItemId" :file-to-sign="fileToSign"
                      @show-overlay="showOverlay" @update-file-is-signed-status="updateFileIsSignedStatus"></SigningModal>
    </b-overlay>
</template>

<script>
import * as constants from '@constants';
import { customerListUrl, groupListUrl, publicationUrl, publicationItemUrl, publicationChangeStatusUrl, fileUploadUrl,
    publicationItemChangeStatusUrl, fileLogsUrl, fileUrl, oauthTokenUrl, publicationItemLockUrl, publicationLockUrl,
    emailsByCustomerUrl, usersByGroupUrl } from '@routes';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { Editor } from '@toast-ui/vue-editor';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import vue2Dropzone from 'vue2-dropzone';
import { saveAs } from 'file-saver';
import PSDatePicker from '@components/PSDatePicker';
import { es } from 'vuejs-datepicker/dist/locale';

import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import 'tui-color-picker/dist/tui-color-picker.css';

extend('required', {
    ...required,
    message: 'Campo requerido'
});

let modalTemplate = '';

export default {
    props: {
        settings: Object,
        membership: Object,
        dateFormat: String,
        modules: Array
    },
    data() {
        return {
            publicationItem: {
                id: 0,
                folio: '',
                field1: '',
                field2: '',
                field3: '',
                field4: '',
                field5: '',
                field1ISO: '',
                field2ISO: '',
                field3ISO: '',
                field4ISO: '',
                field5ISO: '',
                status: 'DRAFT',
                locked: false,
                isEditing: false,
                groups: [],
                files: []
            },
            modalPublication: {
                id: 0,
                folio: '',
                field1: '',
                field2: '',
                field3: '',
                field4: '',
                field5: '',
                field1ISO: '',
                field2ISO: '',
                field3ISO: '',
                field4ISO: '',
                field5ISO: '',
                locked: false,
                groups: [],
                files: []
            },
            publishData: {
                type: '',
                publicationId: 0
            },
            dropzoneOptions: {
                url: '',
                thumbnailWidth: 150,
                maxFilesize: 1024,
                timeout: 300000,
                parallelUploads: 1,
                createImageThumbnails: false,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                },
                dictDefaultMessage: 'Presiona sobre el recuadro para subir archivos'
            },
            editorOptions: {
                usageStatistics: true,
                hideModeSwitch: true,
                plugins: [colorSyntax]
            },
            editorInitialValue: constants.EMAIL_BODY,
            calendar: {
                format: 'yyyy/MM/dd',
                language: es,
                bootstrapStyling: true,
                clearButton: true
            },
            publication: {
                id: 0,
                customer: null,
                publicationDate: '',
                status: 'DRAFT'
            },
            fields: [
                { key: 'isSelected', label: 'Seleccionar' },
                { key: 'folio', label: 'Folio' },
                { key: 'groups', label: 'Grupos' },
                { key: 'locked', label: 'Descarga bloqueada' },
                { key: 'status', label: 'Estatus' },
                { key: 'files', label: 'Archivos' },
                { key: 'actions', label: 'Acciones', class: 'text-right' }
            ],
            fileFields: [
                { key: 'number', label: 'Número', class: 'text-right' },
                { key: 'name', label: 'Nombre', class: 'text-left' },
                { key: 'created', label: 'Fecha de carga', class: 'text-left' },
                { key: 'size', label: 'Tamaño', class: 'text-right' },
                { key: 'createdBy', label: 'Cargado por', class: 'text-left' },
                { key: 'downloadCount', label: 'Cantidad de descargas', class: 'text-right' },
                { key: 'isSigned', label: 'Firmado', class: 'text-center' },
                { key: 'actions', label: 'Acciones', class: 'text-right' }
            ],
            mailData: {
                emails: [],
                cc: '',
                subject: 'Nuevos certificados o informes publicados.',
                body: '',
                attachFiles: false,
                errors: {
                    emails: false
                }
            },
            groupEmails: [],
            selectAll: false,
            customFields: Array(5).fill(null),
            publicationItems: [],
            publicationItemsCache: [],
            customers: [],
            groups: [],
            isLoading: false,
            notificationAction: '',
            notificationType: '',
            publicationToPublish: null,
            sendNotifications: false,
            fileLogs: [],
            fileLogsfields: [
                { key: 'date', label: 'Fecha', sortable: false },
                { key: 'user', label: 'Usuario', sortable: false }
            ],
            file: {
                mimetype: '',
                previewData: ''
            },
            groupsToNotify: [],
            modalPublicationItemId: 0,
            fileToSign: {}
        }
    },
    components: {
        Editor,
        PSDatePicker,
        VueDropzone: vue2Dropzone,
        SigningModal: () => import('@components/SigningModals/' + modalTemplate)
    },
    created() {
        let action = 'Nueva';

        this.$parent.loadData().then(() => {
            this.calendar.format = this.dateFormat;

            this.setCustomFields();
        });

        if (this.$route.name === 'PublicationEdit') {
            this.loadPublicationData();

            action = 'Modificar';
        }

        this.$emit('update-breadcrumb-items', [
            {
                text: 'Publicaciones',
                to: { name: 'Publication' }
            },
            {
                text: action,
                active: true
            }
        ]);

        modalTemplate += this.$route.params.memberName.toLowerCase();
    },
    mounted() {
        this.publicationItem.locked = this.settings.defaults.lockDownload;
    },
    methods: {
        loadPublicationData() {
            this.isLoading = true;

            this.axios.get(publicationUrl(), {
                params: {
                    publicationId: this.$route.params.id ?? this.publication.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let publication = response.data.publication;

                    this.publication.id = publication.id;
                    this.publication.publicationDate = publication.publicationDate;
                    this.publication.status = publication.status;
                    this.publication.customer = publication.customer;

                    this.publicationItems = [];

                    for (let item of publication.publicationItems) {
                        item.isEditing = false;
                        item.isSelected = false;
                        item.state1 = null;
                        item.state2 = null;
                        item.state3 = null;
                        item.state4 = null;
                        item.state5 = null;

                        this.publicationItems.push(item);
                    }
                }
            }).catch(

            ).finally(() => {
                this.isLoading = false;
            });
        },
        setCustomFields() {
            for (let i = this.settings.customFields.length - 1; i >= 0; i--) {
                let field = this.settings.customFields[i];

                if (field.enabled) {
                    this.fields.splice(2, 0, {
                        key: `field${i + 1}`,
                        label: field.name
                    });

                    this.customFields.splice(i, 1, {
                        id: field.id.toString(),
                        name: `field${i + 1}`,
                        placeholder: field.name,
                        type: field.type,
                        required: field.required
                    });
                }
            }
        },
        getCustomers(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(customerListUrl(), {
                params: {
                    searchWord: search
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.customers = response.data.customers;
                } else {
                    this.customers = [];
                }
            }).catch(() => {
                this.customers = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        getCustomerGroups(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            if (this.publication.customer && this.publication.customer.id > 0) {
                this.axios.get(groupListUrl(), {
                    params: {
                        customerId: this.publication.customer.id,
                        searchWord: search
                    }
                }).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.groups = response.data.groups;
                    } else {
                        this.groups = [];
                    }
                }).catch(() => {
                    this.groups = [];
                }).finally(() =>  {
                    if (loading) {
                        loading(false);
                    }
                });
            } else if (loading) {
                loading(false);
            }
        },
        async addPublication() {
            if (this.publication.id === 0) {
                await this.axios.post(publicationUrl(), {
                    customerId: this.publication.customer.id
                }).then(response => {
                    if (response.data.code === constants.CODE_OK) {
                        this.publication.id = response.data.publicationId;
                    }
                }).catch();
            }

            let data = {
                publicationId: this.publication.id,
                publicationItem: {
                    id: this.publicationItem.id,
                    folio: this.publicationItem.folio,
                    locked: this.publicationItem.locked,
                    field1: this.publicationItem.field1,
                    field2: this.publicationItem.field2,
                    field3: this.publicationItem.field3,
                    field4: this.publicationItem.field4,
                    field5: this.publicationItem.field5,
                    groups: this.publicationItem.groups.map(group => group.id)
                }
            };

            await this.axios.post(publicationItemUrl(), data).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let item = response.data.publicationItem;

                    this.publicationItem.id = item.id;
                    this.publicationItem.folio = item.folio;
                    this.publicationItem.field1 = item.field1;
                    this.publicationItem.field1ISO = item.field1ISO;
                    this.publicationItem.field2 = item.field2;
                    this.publicationItem.field2ISO = item.field2ISO;
                    this.publicationItem.field3 = item.field3;
                    this.publicationItem.field3ISO = item.field3ISO;
                    this.publicationItem.field4 = item.field4;
                    this.publicationItem.field4ISO = item.field4ISO;
                    this.publicationItem.field5 = item.field5;
                    this.publicationItem.field5ISO = item.field5ISO;
                    this.publicationItem.isSelected = false;
                }
            });

            this.modalPublication = { ...this.publicationItem };
            this.dropzoneOptions.url = fileUploadUrl(this.modalPublication.id);

            this.publicationItem = {
                id: 0,
                folio: '',
                field1: '',
                field2: '',
                field3: '',
                field4: '',
                field5: '',
                field1ISO: '',
                field2ISO: '',
                field3ISO: '',
                field4ISO: '',
                field5ISO: '',
                status: 'DRAFT',
                locked: false,
                isEditing: false,
                groups: [],
                files: []
            };

            this.$refs.observer.reset();
            this.$bvModal.show('publication-modal');
        },
        showFilesModal(publication) {
            this.modalPublication = { ...publication };
            this.dropzoneOptions.url = fileUploadUrl(this.modalPublication.id);

            this.$bvModal.show('publication-modal');
        },
        toggleEditing(publication) {
            if (publication.isEditing) {
                let index = this.publicationItemsCache.findIndex(item => item.id === publication.id);

                if (index >= 0) {
                    for (let prop in publication) {
                        publication[prop] = this.publicationItemsCache[index][prop];
                    }

                    this.publicationItemsCache.splice(index, 1);
                }

                publication.isEditing = false;
            } else {
                this.publicationItemsCache.push({ ...publication });

                if (this.customFields[0]?.type === 'DATETIME' && publication.field1 !== '') {
                    publication.field1ISO += ' 00:00:00';
                }

                if (this.customFields[1]?.type === 'DATETIME' && publication.field2 !== '') {
                    publication.field2ISO += ' 00:00:00';
                }

                if (this.customFields[2]?.type === 'DATETIME' && publication.field3 !== '') {
                    publication.field3ISO += ' 00:00:00';
                }

                if (this.customFields[3]?.type === 'DATETIME' && publication.field4 !== '') {
                    publication.field4ISO += ' 00:00:00';
                }

                if (this.customFields[4]?.type === 'DATETIME' && publication.field5 !== '') {
                    publication.field5ISO += ' 00:00:00';
                }

                publication.isEditing = true;
            }
        },
        validatePublicationItem(publicationItem) {
            let isValid = true;

            publicationItem.state1 = null;
            publicationItem.state2 = null;
            publicationItem.state3 = null;
            publicationItem.state4 = null;
            publicationItem.state5 = null;

            if (this.customFields[0]?.required && publicationItem.field1.trim() === '') {
                isValid = false;
                publicationItem.state1 = false;
            } else if (this.customFields[1]?.required && publicationItem.field2.trim() === '') {
                isValid = false;
                publicationItem.state2 = false;
            } else if (this.customFields[2]?.required && publicationItem.field3.trim() === '') {
                isValid = false;
                publicationItem.state3 = false;
            } else if (this.customFields[3]?.required && publicationItem.field4.trim() === '') {
                isValid = false;
                publicationItem.state4 = false;
            } else if (this.customFields[4]?.required && publicationItem.field5.trim() === '') {
                isValid = false;
                publication.state5 = false;
            }

            return isValid;
        },
        savePublicationItem(publicationItem) {
            if (this.validatePublicationItem(publicationItem)) {
                this.$swal({
                    title: '¿Guardar los cambios?',
                    icon: 'question'
                }).then(result => {
                    if (result.value) {
                        let { field1, field2, field3, field4, field5 } = this.getCustomFieldsValues(publicationItem);

                        let data = {
                            publicationId: this.publication.id,
                            publicationItem: {
                                id: publicationItem.id,
                                folio: publicationItem.folio,
                                locked: publicationItem.locked,
                                field1,
                                field2,
                                field3,
                                field4,
                                field5,
                                groups: publicationItem.groups.map(item => item.id)
                            }
                        };

                        this.axios.put(publicationItemUrl(), data).then(response => {
                            if (response.data.code === constants.CODE_OK) {
                                let item = response.data.publicationItem;

                                this.$root.$bvToast.toast(response.data.message, {
                                    title: 'Publicaciones',
                                    variant: 'success'
                                });

                                let index = this.publicationItemsCache.findIndex(item => item.id === publicationItem.id);

                                if (index >= 0) {
                                    this.publicationItemsCache.splice(index, 1);
                                }

                                publicationItem.field1 = item.field1;
                                publicationItem.field1ISO = item.field1ISO;
                                publicationItem.field2 = item.field2;
                                publicationItem.field2ISO = item.field2ISO;
                                publicationItem.field3 = item.field3;
                                publicationItem.field3ISO = item.field3ISO;
                                publicationItem.field4 = item.field4;
                                publicationItem.field4ISO = item.field4ISO;
                                publicationItem.field5 = item.field5;
                                publicationItem.field5ISO = item.field5ISO;
                                publicationItem.isEditing = false;
                            } else {
                                this.$bvToast.toast(response.data.message, {
                                    title: 'Publicaciones',
                                    variant: 'danger'
                                });
                            }
                        }).catch(() => {
                            this.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                                title: 'Publicaciones',
                                variant: 'danger'
                            });
                        });
                    }
                });
            }
        },
        getCustomFieldsValues(publicationItem) {
            let originalItem = this.publicationItemsCache.find(item => item.id === publicationItem.id);
            let { field1, field2, field3, field4, field5 } = publicationItem;

            if (this.customFields[0]?.type === 'DATETIME') {
                if (field1 === originalItem.field1) {
                    field1 = originalItem.field1ISO;
                }
            }

            if (this.customFields[1]?.type === 'DATETIME') {
                if (field2 === originalItem.field2) {
                    field2 = originalItem.field2ISO;
                }
            }

            if (this.customFields[2]?.type === 'DATETIME') {
                if (field3 === originalItem.field3) {
                    field3 = originalItem.field3ISO;
                }
            }

            if (this.customFields[3]?.type === 'DATETIME') {
                if (field4 === originalItem.field4) {
                    field4 = originalItem.field4ISO;
                }
            }

            if (this.customFields[4]?.type === 'DATETIME') {
                if (field5 === originalItem.field5) {
                    field5 = originalItem.field5ISO;
                }
            }

            return { field1, field2, field3, field4, field5 };
        },
        onFileUploadSuccess(file, response) {
            if (response.code === constants.CODE_OK) {
                let file = response.file;

                if (file.action === 'PERSIST') {
                    this.modalPublication.files.push({
                        id: file.id,
                        name: file.name,
                        size: file.size,
                        mimeType: file.mimeType,
                        downloadCount: file.downloadCount
                    });
                }

                let publication = this.publicationItems.find(publication => publication.id === this.modalPublication.id);

                if (!publication) {
                    this.publicationItems.push(this.modalPublication);
                }

                this.membership.storageUsage = response.storageUsage;

                this.$root.$bvToast.toast(response.message, {
                    title: 'Publicaciones',
                    variant: 'success'
                });
            }
        },
        onFileUploadError(file, message, xhr) {
            if (xhr && xhr.status === 401) {
                this.refreshToken().then(() => {
                    file.status = 'added';
                    file.previewElement.classList.remove('dz-error');
                    this.$refs.vueDropzone.dropzone.enqueueFile(file);
                }).catch(error => {
                    console.error(error);
                    this.$root.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                });
            } else if (message !== 'Upload canceled.') {
                console.error(message);
                file.previewElement.querySelectorAll('.dz-error-message span')[0]
                    .textContent = 'Ocurrió un error al subir el archivo. Por favor contacte a soporte.';

                this.$root.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                    title: 'Publicaciones',
                    variant: 'danger'
                });
            }
        },
        deleteFile(fileId, fileName) {
            this.$swal({
                title: `¿Eliminar el archivo ${fileName}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.axios.delete(fileUrl(), {
                        data: { fileId }
                    }).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.$root.$bvToast.toast(response.data.message, {
                                title: 'Publicaciones',
                                variant: 'success'
                            });

                            this.membership.storageUsage = response.data.storageUsage;

                            this.loadPublicationData();
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: 'Publicaciones',
                                variant: 'danger'
                            });
                        }
                    }).catch(error => {
                        console.error(error);

                        this.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                            title: 'Publicaciones',
                            variant: 'danger'
                        });
                    });
                }
            });
        },
        onEditorChange() {
            this.mailData.body = this.$refs.emailBody.invoke('getHtml');
            this.$forceUpdate();
        },
        customerSelectClass(errors) {
            if (errors[0]) {
                return 'customer-select-invalid';
            } else {
                return '';
            }
        },
        validatePublicationNotification(action, type, publicationItem = null) {
            if (action === 'LOCK' || type === 'SINGLE' && publicationItem && publicationItem.files.length > 0 ||
                this.selectedPublicationItems.every(item => item.files.length > 0)) {

                let title = '¿Estás seguro de ';

                if (action === 'LOCK') {
                    title += 'desbloquear';

                    if (type === 'SINGLE') {
                        title += ' la descarga?';
                    } else {
                        title += ' las descargas?';
                    }
                } else {
                    title += 'publicar';

                    if (type === 'SINGLE') {
                        title += ' el registro?';
                    } else {
                        title += ' los registros?';
                    }
                }

                this.$swal({
                    title: title,
                    input: 'checkbox',
                    inputPlaceholder: 'Enviar notificaciones',
                    icon: 'question'
                }).then(result => {
                    if ('value' in result) {
                        this.notificationAction = action;
                        this.notificationType = type;
                        this.publicationToPublish = publicationItem;

                        if (result.value) {
                            this.sendNotifications = true;

                            this.mailData = {
                                emails: [],
                                cc: '',
                                subject: 'Nuevos certificados o informes publicados.',
                                body: '',
                                attachFiles: this.settings.defaults.attachFiles,
                                errors: {
                                    emails: false
                                }
                            };

                            // this.mailData.attachFiles = this.settings.defaults.attachFiles;

                            let groupIds = this.selectedGroupsIds;

                            if (type === 'SINGLE') {
                                groupIds = this.publicationToPublish.groups.map(group => group.id);
                            }

                            if (groupIds.length > 0) {
                                this.axios.get(usersByGroupUrl(), {
                                    params: {
                                        groupIds: groupIds.toString()
                                    }
                                }).then(response => {
                                    if (response.data.code === constants.CODE_OK) {
                                        this.groupsToNotify = response.data.groups;

                                        this.$bvModal.show('email-modal');
                                    } else {
                                        this.groupsToNotify = [];
                                    }
                                });
                            }  else {
                                this.$bvModal.show('email-modal');
                            }
                        } else {
                            this.sendNotifications = false;

                            if (action === 'LOCK') {
                                if (type === 'SINGLE') {
                                    this.changePublicationItemLockStatus(publicationItem, false);
                                } else {
                                    this.changePublicationLockStatus(false);
                                }
                            } else {
                                this.publish();
                            }
                        }
                    }
                });
            } else {
                let message = type === 'SINGLE' ? 'Las publicación no tiene archivos agregados' :
                    'Las publicaciones seleccionadas no tienen archivos agregados';

                this.$bvToast.toast(message, {
                    title: 'Publicaciones',
                    variant: 'warning'
                });
            }
        },
        validateUnpublishItem(type, publicationItem, status) {
            this.$swal({
                title: `¿Estás seguro de retirar ${type === 'SINGLE' ? 'la publicación' : 'las publicaciones'}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    if (type === 'SINGLE') {
                        this.changePublicationItemStatus(publicationItem, status);
                    } else {
                        this.changePublicationStatus(status);
                    }
                }
            });
        },
        validateLockItem(type, publicationItem, locked) {
            this.$swal({
                title: `¿Estás seguro de bloquear ${type === 'SINGLE' ? 'la descarga' : 'las descargas'}?`,
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    if (type === 'SINGLE') {
                        this.changePublicationItemLockStatus(publicationItem, locked);
                    } else {
                        this.changePublicationLockStatus(locked);
                    }
                }
            });
        },
        publish() {
            if (this.notificationAction === 'LOCK') {
                if (this.notificationType === 'SINGLE') {
                    if (!this.validateToEmails()) {
                        this.changePublicationItemLockStatus(this.publicationToPublish, false);
                    }
                } else {
                    if (this.showEmailsSelect) {
                        if (!this.validateToEmails()) {
                            this.changePublicationLockStatus(false);
                        }
                    } else {
                        this.changePublicationLockStatus(false);
                    }
                }
            } else {
                if (this.notificationType === 'SINGLE') {
                    if (this.sendNotifications) {
                        if (!this.validateToEmails()) {
                            this.changePublicationItemStatus(this.publicationToPublish, 'PUBLISHED');
                        }
                    } else {
                        this.changePublicationItemStatus(this.publicationToPublish, 'PUBLISHED');
                    }
                } else {
                    if (this.sendNotifications) {
                        if (this.showEmailsSelect) {
                            if (!this.validateToEmails()) {
                                this.changePublicationStatus('PUBLISH');
                            }
                        } else {
                            this.changePublicationStatus('PUBLISH');
                        }
                    } else {
                        this.changePublicationStatus('PUBLISH');
                    }
                }
            }
        },
        changePublicationItemStatus(publicationItem, status) {
            this.isLoading = true;

            let data = {
                publicationItemId: publicationItem.id,
                status: status
            };

            if (this.sendNotifications) {
                data.mailData = this.mailData;

                this.$bvModal.hide('email-modal');
            }

            this.axios.put(publicationItemChangeStatusUrl(), data).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'success'
                    });

                    if (this.sendNotifications) {
                        this.sendNotifications = false;
                    }

                    this.mailData.cc = '';

                    publicationItem.status = status;

                    this.mailData = {
                        emails: [],
                        cc: '',
                        subject: 'Nuevos certificados o informes publicados.',
                        body: '',
                        attachFiles: false,
                        errors: {
                            emails: false
                        }
                    };
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            }).catch(() => {
                this.$root.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                    title: 'Publicaciones',
                    variant: 'danger'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        changePublicationStatus(status) {
            this.isLoading = true;

            let data = {
                publicationId: this.publication.id,
                itemIds: this.selectedPublicationItems.map(item => item.id),
                action: status
            };

            if (status === 'PUBLISH' && this.sendNotifications) {
                // data.mailData = {
                //     attachFiles: this.mailData.attachFiles,
                //     body: this.mailData.body,
                //     cc: this.mailData.cc,
                //     subject: this.mailData.subject
                // };
                data.mailData = this.mailData;
            }

            if (this.sendNotifications) {
                this.$bvModal.hide('email-modal');
            }

            this.axios.put(publicationChangeStatusUrl(), data).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'success'
                    });

                    if (this.sendNotifications) {
                        this.sendNotifications = false;
                    }

                    this.selectAll = false;
                    this.loadPublicationData();
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            }).catch(() => {
                this.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                    title: 'Publicaciones',
                    variant: 'danger'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        changePublicationItemLockStatus(publicationItem, locked) {
            this.isLoading = true;

            let data = {
                publicationItemId: publicationItem.id,
                locked
            };

            if (!locked && this.sendNotifications) {
                data.mailData = this.mailData;
            }

            if (this.sendNotifications) {
                this.$bvModal.hide('email-modal');
            }

            this.axios.put(publicationItemLockUrl(), data).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'success'
                    });

                    if (this.sendNotifications) {
                        this.sendNotifications = false;
                    }

                    publicationItem.locked = locked;

                    this.mailData = {
                        emails: [],
                        cc: '',
                        subject: 'Nuevos certificados o informes publicados.',
                        body: '',
                        attachFiles: false,
                        errors: {
                            emails: false
                        }
                    };
                } else {
                    this.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            }).catch(() => {
                this.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                    title: 'Publicaciones',
                    variant: 'danger'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        changePublicationLockStatus(locked) {
            this.isLoading = true;

            let data = {
                publicationId: this.publication.id,
                itemIds: this.selectedPublicationItems.map(item => item.id),
                locked
            };

            if (!locked && this.sendNotifications) {
                //data.mailData = {
                //    attachFiles: this.mailData.attachFiles,
                //    body: this.mailData.body,
                //    cc: this.mailData.cc,
                //    subject: this.mailData.subject
                //};

                data.mailData = this.mailData;

                this.$bvModal.hide('email-modal');
            }

            this.axios.put(publicationLockUrl(), data).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'success'
                    });

                    if (this.sendNotifications) {
                        this.sendNotifications = false;
                    }

                    this.selectAll = false;
                    this.loadPublicationData();
                } else {
                    this.$bvToast.toast(response.data.message, {
                        title: 'Publicaciones',
                        variant: 'danger'
                    });
                }
            }).catch(() => {
                this.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                    title: 'Publicaciones',
                    variant: 'danger'
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },
        openFileLogsModal(file) {
            if (file.downloadCount > 0) {
                this.axios.get(fileLogsUrl(), {
                    params: {
                        fileId: file.id,
                        action: 'DOWNLOAD'
                    },
                    responseType: 'json'
                }).then(response => {
                    if (response.data.code === 'OK') {
                        this.fileLogs = response.data.logs;
                    }
                });

                this.$bvModal.show('file-logs-modal');
            }
        },
        formatBytes(size) {
            const ratio = 1024, digits = 2;
            let units = ['B', 'KB', 'MB', 'GB'];
            let unit = 0;

            size = parseInt(size);

            while (size > 1024) {
                size /= ratio;
                unit++;
            }

            return `${size.toFixed(digits)} ${units[unit]}`;
        },
        canBePreviewed(file) {
            let validPreviewMimeTypes = ['application/pdf', 'image/png', 'image/jpeg'];

            return validPreviewMimeTypes.includes(file.mimeType);
        },
        canBeSigned(file, status) {
            return this.modules.includes('SIGNING') && status !== 'PUBLISHED' && !file.isSigned &&
                file.mimeType === 'application/pdf';
        },
        showPreview(file) {
            this.axios.get(fileUrl(), {
                params: {
                    fileId: file.id,
                    isPreview: true
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let blob = this.base64ToBlob(response.data.file, response.data.mimeType);

                    this.file.previewData = URL.createObjectURL(blob);
                    this.file.mimetype = response.data.mimeType;

                    this.$bvModal.show('file-preview-modal');
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        variant: 'danger'
                    });
                }
            });
        },
        download(file) {
            this.axios.get(fileUrl(), {
                params: {
                    fileId: file.id,
                    isPreview: false
                },
                responseType: 'blob'
            }).then(response => {
                saveAs(response.data, file.name);
            });
        },
        toggleCalendar(index) {
            this.calendar.calendars[index].show = !this.calendar.calendars[index].show;
        },
        dateChanged(date, id, field) {
            if (id === 0) {
                if (date) {
                    this.publicationItem[field] = `${date.getFullYear()}-${(date.getMonth() +1).toString().padStart(2, '0')}` +
                        `-${(date.getDate()).toString().padStart(2, '0')}`;
                } else {
                    this.publicationItem[field] = '';
                }
            } else {
                let item = this.publicationItems.find(item => item.id === id);

                if (item) {
                    if (date) {
                        item[field] = `${date.getFullYear()}-${(date.getMonth() +1).toString().padStart(2, '0')}` +
                            `-${(date.getDate()).toString().padStart(2, '0')}`;
                    } else {
                        item[field] = '';
                    }
                }
            }
        },
        showSigningModal(publicationItemId, file) {
            this.modalPublicationItemId = 0;
            this.$nextTick(() => {
                this.modalPublicationItemId = publicationItemId;
                this.fileToSign = file;
                this.$bvModal.show('signing-modal');
            });
        },
        refreshToken() {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.set('grant_type', 'refresh_token');
                formData.set('refresh_token', localStorage.getItem('refreshToken'));

                this.axios.post(oauthTokenUrl(), formData).then(response => {
                    localStorage.setItem('accessToken', response.data.access_token);
                    localStorage.setItem('refreshToken', response.data.refresh_token);

                    this.$refs.vueDropzone.setOption('headers', { Authorization: `Bearer ${localStorage.getItem('accessToken')}` });

                    resolve();
                }).catch(reject);
            });
        },
        getUsersEmailsByCustomer(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(emailsByCustomerUrl(), {
                params: {
                    searchWord: search,
                    customerId: this.publication.customer.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.groupEmails = response.data.emails;
                } else {
                    this.groupEmails = [];
                }
            }).catch(() => {
                this.groupEmails = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        toggleSelectAll() {
            this.$nextTick(() => {
                for (let item of this.publicationItems) {
                    item.isSelected = this.selectAll;
                }
            });
        },
        setSelectAllStatus() {
            this.$nextTick(() => {
                this.selectAll = this.publicationItems.every(item => item.isSelected);
            });
        },
        validateToEmails() {
            if (this.publicationToPublish) {
                this.mailData.errors.emails = this.publicationToPublish.groups.length === 0 && this.mailData.emails.length === 0;
            } else {
                this.mailData.errors.emails = this.mailData.emails.length === 0;
            }

            return this.mailData.errors.emails;
        },
        showOverlay(show) {
            this.isLoading = show;
        },
        updateFileIsSignedStatus(params) {
            let itemIndex = this.publicationItems.findIndex(item => item.id === params.publicationItemId);
            let fileIndex = this.publicationItems[itemIndex].files.findIndex(file => file.id === params.fileId);

            this.publicationItems[itemIndex].files[fileIndex].isSigned = true;
        },
        base64ToBlob(base64, mimeType) {
            const binStr = atob(base64);
            const length = binStr.length;
            const arr = new Uint8Array(length);

            for (let i = 0; i < length; i++) {
                arr[i] = binStr.charCodeAt(i);
            }

            return new Blob([arr], { type: mimeType });
        }
    },
    watch: {
        settings: {
            handler() {
                this.setCustomFields();
            },
            deep: true
        },
        'mailData.emails': {
            handler(emails) {
                this.mailData.errors.emails = this.publicationToPublish && this.publicationToPublish.groups.length === 0 && emails.length === 0;
            },
            deep: true
        }
    },
    computed: {
        customFieldsEnabled() {
            let fields = [];

            for (let field of this.customFields) {
                if (field) {
                    fields.push(field.name);
                }
            }

            return fields;
        },
        selectedPublicationItems() {
            return this.publicationItems.filter(item => item.isSelected);
        },
        publicationItemsToPublish() {
            return this.selectedPublicationItems.filter(item => item.status === 'DRAFT');
        },
        publicationItemsToUnpublish() {
            return this.selectedPublicationItems.filter(item => item.status === 'PUBLISHED');
        },
        publicationItemsToLock() {
            return this.selectedPublicationItems.filter(item => !item.locked);
        },
        publicationItemsToUnlock() {
            return this.selectedPublicationItems.filter(item => item.locked);
        },
        invalidFeedback() {
            return 'Ingresa el campo';
        },
        showEmailsSelect() {
            return this.selectedPublicationItems.length > 0 && this.selectedPublicationItems.some(item => item.groups.length === 0);
        },
        showGroupsTags() {
            return this.selectedPublicationItems.length > 0 && this.selectedPublicationItems.some(item => item.groups.length > 0);
        },
        selectedGroupsIds() {
            let groups = [];
            let itemsSelected = this.selectedPublicationItems.filter(item => item.groups.length > 0).map(item => item.groups);

            itemsSelected.forEach(item => {
                item.forEach(group => {
                    if (!groups.includes(group.name)) {
                        groups.push(group.id);
                    }
                });
            });

            return groups;
        }
    }
}
</script>

<style>

</style>